import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=6254090e&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "./Comments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports